import { siteUrl } from 'services/cutileiApi'
import AuthService from 'services/auth'
import CopyButton from 'components/CopyButton'
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'

import {
  Container,
  Column,
  Row,
  InfoText,
  LinkText
} from './styles'

export default function ScheduleLinkModal ({
  visible,
  onlineScheduleEnabled,
  onClose: handleClose
}) {
  const businessId = AuthService.getBusinessId ()
  const businessUrl = `${siteUrl}/businesses/${businessId}/schedule`

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Agendamento por link</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Container>
            {onlineScheduleEnabled ? (
              <Column>
                <InfoText style={{marginBottom: 10}}>
                  Você pode copiar seu link de agendamentos e colocar em suas redes sociais ou enviar para seus clientes.
                </InfoText>
                <InfoText>
                  Através desse link, seus clientes vão poder agendar serviços em seu salão.
                </InfoText>
                <Row>
                  <LinkText to={`/businesses/${businessId}/schedule`}>
                    {businessUrl}
                  </LinkText>
                  <CopyButton text={businessUrl}/>
                </Row>
              </Column>
            ) : (
              <Column>
                <InfoText>
                  Você ainda não configurou serviços para aceitarem agendamentos online.
                </InfoText>
                <InfoText>
                  Clique no link abaixo para ir para a configuração de seus serviços e habilitar agendamentos online.
                </InfoText>
                <LinkText to='/business/config' state={{ configOption: 'services' }}>
                  Configurar meus serviços
                </LinkText>
              </Column>
            )}
          </Container>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
